export const KGoExperience = {
  THREE_D: 'ThreeD',
  VIDEO_ANALYSIS_ONLY: 'VideoAnalysisOnly',
  BABE_RUTH: 'BabeRuth',
  PERFECT_GAME: 'PerfectGame'
};
